import { unsafeUpdateAt } from "fp-ts/lib/Array";
import { writable } from "svelte/store";
export const CARDS = [];
export const SUITS = ['clubs', 'diamonds', 'hearts', 'spades'];
export const RANKS = [6, 7, 8, 9, 10, 'A', 'J', 'K', 'Q'];
for (const suit of SUITS)
    for (const rank of RANKS)
        CARDS.push({ suit, rank });
const sample = (array) => array.length > 0
    ? array[Math.floor(Math.random() * array.length)]
    : null;
const shuffle = (array) => {
    const shuffled = array.slice(0);
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = temp;
    }
    return shuffled;
};
const modifyAt = (array, i, f) => array.map((x, j) => j == i ? f(x) : x);
const allCards = ({ stacks, spare, deck }) => {
    const cards = stacks.flat();
    cards.push(...deck);
    if (spare)
        cards.push(spare);
    return cards;
};
const newGameState = () => {
    const stacks = Array.from(Array(9)).map(() => []);
    const deck = shuffle(CARDS);
    return {
        stacks,
        spare: null,
        deck
    };
};
export const createGameStore = () => {
    const { subscribe, set, update } = writable(newGameState());
    const dealOne = () => update(s => {
        const { stacks, spare, deck } = s;
        if (!deck.length)
            return s;
        const is = stacks.map((x, i) => x.length < 4 ? i : -1).filter(x => x >= 0);
        const i = sample(is);
        if (i == null)
            return s;
        const c = deck[deck.length - 1];
        return {
            stacks: unsafeUpdateAt(i, [...stacks[i], c], stacks),
            spare,
            deck: deck.slice(0, -1),
        };
    });
    return {
        subscribe,
        set,
        update,
        dealOne,
        reset: () => update(() => newGameState())
    };
};
export const store = createGameStore();
